
import { IApp, IAppExtended } from './app';
import { ILabel } from './label';
import { ILocale } from './locale';
import { IMarket } from './market';
import { ILocalizedMenu } from './menu';
import { IRouteLink } from './route';
import { IPrettify } from './various';

export type ILayout<T extends IAppExtended = IAppExtended> = {
  labels: ILabel[];
  locale: string;
  locales: ILocale[];
  market: string;
  markets: IMarket[];
  app: IPrettify<IApp<T>>;
  menu: Record<string, ILocalizedMenu>;
  topLevelHrefs: Record<string, string>;
  topLevelRoutes: Record<string, IRouteLink>;
  tree?: IRouteLink;
};
